import React from "react";
import styled from "styled-components";
import { func, string } from "prop-types";

import Button from "components/shared/Button";
import Copy from "components/shared/Copy";

const StyledPanel = styled.div`
  flex: 0 0 100%;
  max-width: 350px;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: white;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-top: 1rem;

  text-align: center;

  @media (min-width: ${({ theme }) => theme.screen.desktop}px) {
    flex: 0 0 30%;
    width: 350px;
  }
`;

const StyledButton = styled(Button)`
  width: 7rem;
  height: 2rem;
`;

const StyledImage = styled.img`
  margin-bottom: 0.5rem;
  max-height: 110px;
`;

export default function CareSolvedOption({
  buttonAction,
  buttonLabel,
  description,
  icon,
  name
}) {
  return (
    <StyledPanel>
      <Copy
        weight="700"
        size={1.2}
        margin="0.5rem 1rem 1rem 1rem"
        color="darkBlue"
        minHeight="66px"
        verticalAlignment="center"
      >
        {name}
      </Copy>
      <StyledImage src={icon} alt="care option" />
      <Copy color="midGrey" minHeight="125px" size={0.8} weight="600">
        {description}
      </Copy>
      <StyledButton
        label={buttonLabel}
        onClick={buttonAction}
        background="blue"
        textColour="white"
      />
    </StyledPanel>
  );
}

CareSolvedOption.propTypes = {
  buttonAction: func.isRequired,
  buttonLabel: string.isRequired,
  description: string.isRequired,
  icon: string.isRequired,
  name: string.isRequired
};
